// Countries Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

export const setFullCountriesListEn = async ({ commit }) => {
  let countriesList = []

  try {
    const result = await Axios.get('countries_list_en')
    result.data.data.forEach(country => {
      countriesList.push({
        value: country.country_id,
        text: country.country_en
      })
    })
    commit('setFullCountriesListEn', countriesList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

export const setFullCountriesListAr = async ({ commit }) => {
  let countriesList = []

  try {
    const result = await Axios.get('countries_list_ar')
    result.data.data.forEach(country => {
      countriesList.push({
        value: country.country_id,
        text: country.country_ar
      })
    })
    commit('setFullCountriesListAr', countriesList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
